/*eslint-disable */
import store from '../store/index';
import  {IEventCategoriesAsset } from '@/interfaces/IEventCategoriesAsset';

const eventToIconMapper: IEventCategoriesAsset = {
  ROAD: 'marker_road_closed',
  HAZARD: 'marker_hazards',
  CONSTRUCTION: 'marker_road_works',
  ACCIDENT: 'marker_accidents',
  JAM: 'marker_hazards',
  OTHER: 'marker_hazards',
};

export default (capEventCode: string): string => {
  // eslint-disable-next-line no-prototype-builtins
  const { contrast} = store.state;
  const iconContrastType = contrast ? 'dark' : 'light';

  if (eventToIconMapper.hasOwnProperty(capEventCode)) {
    const iconName = eventToIconMapper[capEventCode as keyof IEventCategoriesAsset];
    const contrastIcon = `${iconName}--${iconContrastType}.svg`;

    return contrastIcon;
  }

  return `${eventToIconMapper.OTHER}--${iconContrastType}.svg`;
};
